<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { Text, Alert, CardGrid, SelectCard } from '@Shelly/shelly-design-system';
	import { capFirstChar } from '../../../../../../../../../helpers/utilities';
	import { format } from 'svelte-i18n';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let actions = [];
	export let active_actions = []; // because it is only one action we can be sure that active_actions contains only one element
	export let sceneIsValid; // Do not remove this line, it is used in the parent component and its validation

	const dispatch = createEventDispatcher();

	let title = actions[0]?.title || 'Unknown element';
	let values = actions[0]?.values || [];

	const mappedActionIcons = {
		0: 'fas fa-unlock text-success',
		1: 'fas fa-lock text-danger',
		2: 'fas fa-door-open text-primary',
	};

	$: selectedAction = active_actions[0]?.value || undefined;

	const _prepare_props_by_id = (id, _val) => {
		switch (id) {
			case 'bolt_state':
				return $format(`label_action_bolt_state_${_val}`);

			default:
				return {};
		}
	};

	let deviceStateList = [
		...actions[0]?.values.map((action, i) => {
			return {
				id: action,
				title: _prepare_props_by_id(actions[0].id, action),
				icon: mappedActionIcons[i],
			};
		}),
	];

	const onChangeDeviceAction = (action) => {
		active_actions[0] = { name: actions[0].id, value: action };
		dispatch('change_active', { new_active: [...active_actions] });
	};
</script>

<Text element="h2" class="mb-s">{capFirstChar($format(title))}</Text>
{#if values.length > 0}
	{#if actions[0].alert}
		<Alert class="mb-s" heading={actions[0].alert} type={'info'} />
	{/if}

	<CardGrid sm={200} md={200} xl={200} noPaddingBottom>
		{#each deviceStateList as card, i}
			<div class="d-flex">
				<SelectCard
					cardBgColor={$showNewLayout ? 'color-1' : undefined}
					class="width-full"
					type="horizontal"
					variant="radio"
					title={card.title}
					icon={card.icon}
					selected={card.id === selectedAction}
					on:click={() => {
						onChangeDeviceAction(card.id);
					}}
				/>
			</div>
		{/each}
	</CardGrid>
{/if}
